import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { fetchSliceOptions } from '../fetch-reducer';
import { Page, PageDetails } from '../../models/page';
import { Version } from '../../models/version';
import { EntityWithErrorState } from '..';
import {
  AdminTermsOverviewApiResponse,
  PageWithVersionResponse,
} from '../../api/responses/api-response-types';

export type AdminPagesState = EntityWithErrorState<Page[]>;

export type AdminPageDetailsState = EntityWithErrorState<Page>;

export type PageOperationsState = EntityWithErrorState<Page>;

export type PreviewPageState = EntityWithErrorState<PageDetails>;

export type CreatePageState = EntityWithErrorState<PageDetails>;

export interface AdminState {
  adminPages: AdminPagesState;
  adminPageDetails: AdminPageDetailsState;
  savePage: PageOperationsState;
  previewPage: PreviewPageState;
  createPage: CreatePageState;
}

export const adminPagesSlice = createSlice(
  fetchSliceOptions({
    sliceName: 'adminPages',
    initialStatePayload: [],
    processPayload: (payload: AdminTermsOverviewApiResponse) =>
      payload.collection,
  })
);

export const adminPageSlice = createSlice(
  fetchSliceOptions({
    sliceName: 'adminPage',
    initialStatePayload: null,
    additionalActions: {
      save: (
        state: AdminState['adminPageDetails'],
        action: PayloadAction<{ page: Page; version: Version }>
      ) => {
        const { version, page } = action.payload;

        const idx = state.entity.versions.findIndex(
          (v: Version) => v.id == version.id
        );
        state.entity.versions[idx] = version;
        state.entity = { ...page, versions: state.entity.versions };
      },
      add: (state, action) => {
        const { version } = action.payload;
        state.entity.versions.unshift(version);
      },
    },
  })
);

export const saveVersionSlice = createSlice(
  fetchSliceOptions({
    sliceName: 'page',
    initialStatePayload: null,
  })
);

export const previewPageSlice = createSlice(
  fetchSliceOptions({
    sliceName: 'previewPage',
    initialStatePayload: null,
  })
);

export const createPageSlice = createSlice(
  fetchSliceOptions({
    sliceName: 'createPage',
    initialStatePayload: null,
  })
);
